<template>
    <div class="footer-wrapper">
        <div class="footer-content">
            <div class="footer-main">
                <div class="footer-logo">
                    <img :src="footerLogoPath" :alt="companyName">
                </div>
                <div class="footer-info">
                    <p class="info-item">公司地址：{{ footerAddress }}</p>
                    <p class="info-item">联系电话：{{ footerPhone }}</p>

                </div>
                <div class="footer-qrcode">
                    <img src="@/assets/image/new_slices/weixin.jpg">
                </div>
            </div>
        </div>
        <div class="footer-bottom" v-if="footerIcp">
            <span>{{ footerIcp }}</span>
        </div>
    </div>
</template>

<script>

export default {
    computed: {
        companyName() {
            return this.$channelMaterial.getCompanyName()
        },
        footerLogoPath() {
            return this.$channelMaterial.getFooterLogoPath()
        },
        footerAddress() {
            return this.$channelMaterial.getFooterAddress()
        },
        footerPhone() {
            return this.$channelMaterial.getFooterPhone()
        },
        footerIcp() {
            return this.$channelMaterial.getFooterIcp()
        }
    }
}
</script>

<style lang="less" scoped>
.footer-wrapper {
    background-color: #2d343d;
}

.footer-content {
    position: relative;
    margin: 0 auto;
    padding: 30px 20px 20px;
}

.footer-main {

    display: flex;
    justify-content: center;

}

.footer-logo {
    position: absolute;
    left: 20px;
    top: 40px;

    img {
        height: 27px;
        width: 80px;
    }
}

.footer-info {
    flex: 1;
    text-align: center;

    .info-item {
        margin: 0;
        padding: 4px 0;
        font-family: PingFang SC, PingFang SC;
        font-size: 14px;
        color: #8A8F99;
        line-height: 1.6;
    }
}

.footer-qrcode {
    position: absolute;
    right: 20px;
    top: 26px;

    img {
        width: 67px;
        height: 67px;
    }
}

.footer-bottom {
    text-align: center;
    padding: 15px 0;
    border-top: 1px solid #3d444d;

    span {
        font-family: PingFang SC, PingFang SC;
        font-size: 12px;
        color: #8A8F99;
    }
}
</style>